import { render, staticRenderFns } from "./AudioVideoPage.vue?vue&type=template&id=187fc01a&scoped=true"
import script from "./AudioVideoPage.vue?vue&type=script&lang=js"
export * from "./AudioVideoPage.vue?vue&type=script&lang=js"
import style0 from "./AudioVideoPage.vue?vue&type=style&index=0&id=187fc01a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187fc01a",
  null
  
)

export default component.exports